import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './BackButton.css';

const BackButton = ({ onClick, label = 'Back' }) => (
  <button type="button" className="page-back-btn" onClick={onClick}>
    <FontAwesomeIcon icon={faArrowLeft} /> {label}
  </button>
);

export default BackButton;
